module.exports = __webpack_public_path__ + "assets/364167c0c19157adbbeb71379829e155.mp3";